import Vue from 'vue';
import PortalVue from 'portal-vue'
import VueTippy, { TippyComponent } from "vue-tippy";
import store from './store';
import translationPlugin from './plugins/translationPlugin';
import Vue2TouchEvents from 'vue2-touch-events'
import vClickOutside from 'v-click-outside'
import HoverIntent from 'vue2-hover-intent';
import alert from './components/alerts/AlertComponent.vue';
import alertBridge from './components/bridge/AlertBridgeComponent.vue';

const element = document.getElementById('app');
const activeLocale = element.getAttribute('data-locale') || 'en';
Vue.prototype.$activeLocale = activeLocale;
Vue.use(translationPlugin);
Vue.use(vClickOutside)
Vue.directive('hover-intent', HoverIntent);

var VueScrollTo = require('vue-scrollto');
Vue.use(VueTippy, {
    directive: "tippy",
    theme: "light",
    flipDuration: 0,
  });
Vue.use(VueScrollTo)
Vue.use(PortalVue)
Vue.use(Vue2TouchEvents)
Vue.filter('pluralize', (word, amount) => (amount > 1 || amount == 0) ? `${word}s` : word)

Vue.component('alert-bridge', alertBridge);
Vue.component("tippy", TippyComponent);
Vue.component('alert', alert);

Vue.component('NotificationBanner', () => import( /* webpackChunkName: "notification-banner-component" */ './components/NotificationBanner.vue'));
Vue.component('ModalComponent', () => import( /* webpackChunkName: "modal-component" */ './components/modals/ModalComponent.vue'));
Vue.component('PopupComponent', () => import( /* webpackChunkName: "popup-component" */ './components/modals/PopupComponent.vue'));
Vue.component('QuickContactFormComponent', () => import( /* webpackChunkName: "quick-contact-form-component" */ './components/forms/QuickContactFormComponent.vue'));
Vue.component('MachinedSealFormComponent', () => import( /* webpackChunkName: "machined-seal-form-component" */ './components/forms/MachinedSealFormComponent.vue'));
Vue.component('CylinderPartFormComponent', () => import( /* webpackChunkName: "cylinder-part-form-component" */ './components/forms/CylinderPartFormComponent.vue'));
Vue.component('MechanicalSealFormComponent', () => import( /* webpackChunkName: "mechanical-seal-form-component" */ './components/forms/MechanicalSealFormComponent.vue'));
Vue.component('QuickOrderFormComponent', () => import( /* webpackChunkName: "quick-order-form-component" */ './components/forms/QuickOrderFormComponent.vue'));
Vue.component('NewsletterFormComponent', () => import( /* webpackChunkName: "newsletter-form-component" */ './components/forms/NewsletterFormComponent.vue'));
Vue.component('GeneralContactFormComponent', () => import( /* webpackChunkName: "general-contact-form-component" */ './components/forms/GeneralContactFormComponent.vue'));
Vue.component('QuickRegisterComponent', () => import( /* webpackChunkName: "quick-register-component" */ './components/forms/QuickRegisterComponent.vue'));

Vue.component('BasketComponent', () => import( /* webpackChunkName: "basket-component" */ './components/basket/BasketComponent.vue'));
Vue.component('BasketMenuComponent', () => import( /* webpackChunkName: "basket-menu-component" */ './components/basket/BasketMenuComponent.vue'));
Vue.component('FloatingBasketComponent', () => import( /* webpackChunkName: "floating-basket-component" */ './components/basket/FloatingBasketComponent.vue'));

Vue.component('CheckoutDetailsComponent', () => import( /* webpackChunkName: "checkout-details-component" */ './components/checkout/CheckoutDetailsComponent.vue'));
Vue.component('CheckoutSummaryComponent', () => import( /* webpackChunkName: "checkout-summary-component" */ './components/checkout/CheckoutSummaryComponent.vue'));
Vue.component('CheckoutShippingComponent', () => import( /* webpackChunkName: "checkout-shipping-component" */ './components/checkout/CheckoutShippingComponent.vue'));
Vue.component('CheckoutPaymentComponent', () => import( /* webpackChunkName: "checkout-payment-component" */ './components/checkout/CheckoutPaymentComponent.vue'));

Vue.component('MobileMenuButton', () => import( /* webpackChunkName: "mobile-menu-button-componentt" */ './components/navigation/MobileMenuButtonComponent.vue'));
Vue.component('MobileSearchButton', () => import( /* webpackChunkName: "mobile-search-button-component" */ './components/navigation/MobileSearchButtonComponent.vue'));
Vue.component('NavigationMenu', () => import( /* webpackChunkName: "navigation-menu-component" */ './components/navigation/NavigationMenuComponent.vue'));
Vue.component('MegaMenu', () => import( /* webpackChunkName: "mega-menu-component" */ './components/navigation/MegaMenuComponent.vue'));
Vue.component('MegaMenuItem', () => import( /* webpackChunkName: "mega-menu-component" */ './components/navigation/MegaMenuItemComponent.vue'));
Vue.component('MegaMenuSubItem', () => import( /* webpackChunkName: "mega-menu-sub-item-component" */ './components/navigation/MegaMenuSubItemComponent.vue'));
Vue.component('MenuItem', () => import( /* webpackChunkName: "mega-menu-sub-item-component" */ './components/navigation/MenuItemComponent.vue'));
Vue.component('QuickOrderComponent', () => import( /* webpackChunkName: "quick-order-component" */ './components/quick-order/QuickOrderComponent.vue'));

Vue.component('PaginationComponent', () => import( /* webpackChunkName: "pagination-component" */ './components/category/PaginationComponent.vue'));
Vue.component('SideBarFilterComponent', () => import( /* webpackChunkName: "side-bar-component" */ './components/category/SideBarFilterComponent.vue'));
Vue.component('ResultsComponent', () => import( /* webpackChunkName: "results-component" */ './components/category/ResultsComponent.vue'));

Vue.component('ProductCarouselComponent', () => import( /* webpackChunkName: "product-carousel-component" */ './components/carousel/ProductCarouselComponent.vue'));
Vue.component('FlickingComponent', () => import( /* webpackChunkName: "flicking-component" */ './components/carousel/FlickingComponent.vue'));

Vue.component('FindASealComponent', () => import( /* webpackChunkName: "find-a-seal-component" */ './components/search/FindASealComponent.vue'));
Vue.component('FindACylinderKitComponent', () => import( /* webpackChunkName: "find-a-cylinder-kit-component" */ './components/search/FindACylinderKitComponent.vue'));
Vue.component('FindASealKitComponent', () => import( /* webpackChunkName: "find-a-seal-kit-component" */ './components/search/FindASealKitComponent.vue'));
Vue.component('BlogFilterComponent', () => import( /* webpackChunkName: "blog-filter-component" */ './components/filters/BlogFilterComponent.vue'));
Vue.component('TagFilterComponent', () => import( /* webpackChunkName: "tag-filter-component" */ './components/filters/TagFilterComponent.vue'));

Vue.component('FilterComponent', () => import( /* webpackChunkName: "filter-component" */ './components/product/FilterComponent.vue'));
Vue.component('ProductComponent', () => import( /* webpackChunkName: "product-component" */ './components/product/ProductComponent.vue'));
Vue.component('CardComponent', () => import( /* webpackChunkName: "card-component" */ './components/product/CardComponent.vue'));
Vue.component('MiniCardComponent', () => import( /* webpackChunkName: "mini-card-component" */ './components/product/MiniCardComponent.vue'));

Vue.component('TabComponent', () => import( /* webpackChunkName: "tab-component" */ './components/tabs/TabComponent.vue'));
Vue.component('TabGroupComponent', () => import( /* webpackChunkName: "tab-group-component" */ './components/tabs/TabGroupComponent.vue'));
Vue.component('TabListComponent', () => import( /* webpackChunkName: "tab-list-component" */ './components/tabs/TabListComponent.vue'));
Vue.component('TabPanelComponent', () => import( /* webpackChunkName: "tab-panel-component" */ './components/tabs/TabPanelComponent.vue'));
Vue.component('TabPanelsComponent', () => import( /* webpackChunkName: "tab-panels-component" */ './components/tabs/TabPanelsComponent.vue'));

var elementExists = document.getElementById("app");

if (elementExists) {
	const app = new Vue({
	   el: '#app',
	   store,
       data() {
        return {
          activeMenuItemIndex: 0,
          activeSubMenuItemIndex: 1,
        };
      },
       strict: true,
	});
}
